import { module as BaseModule } from 'modujs'
import { gsap } from 'gsap'

export default class extends BaseModule {
  init () {
    const zoomInButton = this.el.querySelector('[data-map-zoom-in]')
    zoomInButton?.addEventListener('click', () => {
      const zoomIn = new CustomEvent('map:zoomIn')
      window.dispatchEvent(zoomIn)
    })

    const zoomOutButton = this.el.querySelector('[data-map-zoom-out]')
    zoomOutButton?.addEventListener('click', () => {
      const zoomOut = new CustomEvent('map:zoomOut')
      window.dispatchEvent(zoomOut)
    })

    const fullscreenButton = this.el.querySelector('[data-map-fullscreen]')
    fullscreenButton?.addEventListener('click', () => {
      const fullscreen = new CustomEvent('map:fullscreen')
      window.dispatchEvent(fullscreen)
    })

    const caption = document.querySelector('[data-map-caption]')
    const captionCloseBtn = document.querySelector('[data-map-caption-close]')
    captionCloseBtn?.addEventListener('click', () => {
      caption.style.display = 'none'
      localStorage.setItem('hide_caption', 'true')
    })

    if (localStorage.getItem('hide_caption') === 'true') {
      caption.style.display = 'none'
    }
  }
}
